import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/data/images";
import { PageHero } from "@/components/PageHero";
import { PhotoCard, CardGrid } from "@/components/Cards";

export default function Solutions() {
  const { content } = useLang();
  const { solutionsPage } = content;
  return (
    <>
      <PageHero label={solutionsPage.title} title={solutionsPage.heading} intro={solutionsPage.intro} image={IMAGES.solutionsPage} />
      <section className="bg-white" data-testid="solutions-grid-section">
        <div className="container-x pt-8 pb-20 md:pt-10 md:pb-28">
          <CardGrid cols="sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" className="gap-y-14">
            {solutionsPage.sections.map((s) => (
              <PhotoCard key={s.slug} to={`/solutions/${s.slug}`} image={IMAGES.sectors[s.slug]} title={s.title} text={s.text} tall cta={s.cta} testid={`solution-card-${s.slug}`} />
            ))}
          </CardGrid>
        </div>
      </section>
    </>
  );
}
